<script lang="ts">
    import { _ } from "svelte-i18n"
    import { scrollTo } from "svelte-scrollto"
    import { get } from "lodash"
    import ChevronDownIcon from "svelte-material-icons/ChevronDown.svelte"
    import DeleteIcon from "svelte-material-icons/Delete.svelte"
    import CheckIcon from "svelte-material-icons/Check.svelte"
    import { navigate } from "../../../../../vendor/svelte-routing"

    import { breadcrumbs, location, openRalChooserOverlay, contentOverlay, showOfferAssistant } from "../../../store"
    import { clickOutside } from "../../../utils"
    import { langField } from "../../../i18n"
    import { apiBaseURL, OfferAssistantFTPAssetsUrl } from "../../../config"

    import MailboxFilterChoices from "./MailboxFilterChoices.svelte"
    import MailboxFilterProductPreview from "./MailboxFilterProductPreview.svelte"
    import OfferAssistant from "./OfferAssistant/OfferAssistant.svelte"
    import ProductInquiry from "../../product/ProductInquiry.svelte"

    let offerAssistantId: string = "mailboxes"
    let offerAssistantReset: boolean = false

    let configopen = false
    let innerWidth: number
    let activeColor: RALColor
    let activeOptions: string[] = []

    // Function for Mobile Types
    let clientwidth
    let extraMargin = 0
    function set_endwidth(clientwidth) {
        const elements = clientwidth / 120
        const fullElements = Math.trunc(elements)
        const partElement = elements - fullElements
        if (partElement > 0.3 && partElement < 0.8) {
            // dont change space
            extraMargin = 0
            return
        }

        let base = 0.5
        if (partElement > 0.5) base = -0.5

        const spaceFactor = partElement + base

        extraMargin = (120 * spaceFactor) / elements
    }
    $: set_endwidth(clientwidth)

    export let products: Product[] // from filter projection query outside
    export let previewProduct: Product // from full query outside of this module
    export let config: FilterEntry[]

    type ChoiceT = {
        code: number
        label: string
        labelLong?: string
        onSelect?: Function
    }
    type CtxConfObj = {
        label: string
        field: string
        choices: ChoiceT[]
    }
    let currentChoice: {
        [context: string]: ChoiceT
    } = {}
    export let currentFilter: {
        [field: string]: number
    }
    function setCurrentFilter(f) {
        if (!currentFilter && !f) return
        currentFilter = f
    }
    function choice2Filter(choice) {
        const _f = {}
        let _setIt = false
        for (let ctx in choice) {
            _setIt = true
            _f[contextConf[ctx].field] = choice[ctx]?.code
        }
        setCurrentFilter(_setIt ? _f : undefined)
    }
    $: choice2Filter(currentChoice)

    // set valid codes for context choice by filtering products based on filter
    function getValidCodes(filter, field: string, isStepBack: boolean, stripCurrentField = true) {
        // console.log(
        //     "getValidCodes",
        //     filter,
        //     field,
        //     isStepBack,
        //     stripCurrentField
        // )
        const _filter = Object.assign({}, filter)
        if (stripCurrentField) {
            // strip current field from filter
            delete _filter[field]
        }

        // strip filter after context for back jump
        if (isStepBack) {
            let isCurCtx = false
            config.forEach((x) => {
                if (x.context == currentCtx) {
                    isCurCtx = true
                }
                if (isCurCtx) {
                    delete _filter[contextConf[x.context].field]
                }
            })
        }

        const _validCodes = {}
        products
            .filter((p) => {
                for (let f in _filter) {
                    if (get(p, f) != _filter[f]) {
                        // filter does not match
                        return false
                    }
                }
                return true
            })
            .forEach((p) => {
                const _code = get(p, field)
                if (typeof _code === "number") {
                    _validCodes[_code] = true
                }
            })

        return _validCodes
    }

    function validateContext(context: string, isStepBack: boolean, stripCurrentField = true): { [code: number]: true } {
        // console.log("validateContext")
        let _validCodes = getValidCodes(currentFilter, currentField, isStepBack, stripCurrentField)

        const validCodesInThisCtx = Object.keys(_validCodes).length
        if (!validCodesInThisCtx) {
            // no valid selection, so reset following contexts
            let curCtxFound = false
            for (let i = 0; i < config.length; i++) {
                if (context == config[i].context) {
                    curCtxFound = true
                }
                if (curCtxFound) {
                    delete currentChoice[config[i].context]
                }
            }
            choice2Filter(currentChoice)
            _validCodes = getValidCodes(currentFilter, contextConf[context].field, isStepBack)
        }
        // console.log("_validCodes", _validCodes)
        return _validCodes
    }
    let validCodes: { [code: number]: true } = {}
    let currentField: string
    // watch context change and filter choices
    $: {
        if (!contextConf[currentCtx]) {
            console.log("MISSING: ", currentCtx)
        }
        if (currentCtx && currentField != contextConf[currentCtx].field) {
            currentField = contextConf[currentCtx].field
            validCodes = validateContext(currentCtx, contextBacknav)
        }
    }

    $: if (currentChoice) {
        // check if choice changed and reset next
        let nextCtx: string
        for (let i = 0; i < config.length; i++) {
            if (currentCtx == config[i - 1]?.context) {
                nextCtx = config[i].context
                break
            }
        }
        if (nextCtx) {
            validateContext(nextCtx, false, false)
        }
    }

    const contextConf: {
        [context: string]: CtxConfObj
    } = {
        BK_Anzahl_Briefkasten: {
            label: "Anlagengröße",
            field: "config_params.postboxes_count",
            choices: [
                { code: 1, label: "1 Briefkasten" },
                { code: 2, label: "2 Briefkästen" },
                { code: 3, label: "3 Briefkästen" },
                { code: 4, label: "4 Briefkästen" },
                { code: 5, label: "5 Briefkästen" },
                { code: 6, label: "6 Briefkästen" },
            ],
        },
        BK_Einbauart: {
            label: "Einbauart",
            field: "config_params.installation_type_code",
            choices: [
                { code: 1, label: "Unterputz" },
                { code: 2, label: "Aufputz" },
                { code: 3, label: "freistehend, einbetoniert" },
                { code: 4, label: "freistehend, aufgeschraubt" },
                //{ code: 5, label: "in Grenzmauer eingelassen" },
                //{ code: 6, label: "in Grenzzaun integriert" },
            ],
        },
        BK_Sprechfeld_Klingel: {
            label: "Sprechfeld / Klingel",
            field: "config_params.intercom_bell_code",
            choices: [
                { code: 1, label: "ohne Sprechfeld/Klingel" },
                { code: 2, label: "Sprechfeld/Klingel rechts" },
                { code: 3, label: "Sprechfeld/Klingel links" },
                { code: 4, label: "Sprechfeld/Klingel oben" },
            ],
        },
        BK_Produktlinie: {
            label: "Produktlinie",
            field: "config_params.line_code",
            choices: [
                { code: 1, label: "TETRO" },
                { code: 2, label: "PRISMA" },
                { code: 3, label: "RS2000" },
                { code: 4, label: "RS4000" },
                { code: 5, label: "QUADRA" },
                { code: 6, label: "Putzrahmen rund" },
                { code: 7, label: "Putzrahmen eckig" },
                { code: 8, label: "Putzrahmen Prisma" },
                { code: 9, label: "BASIC" },
                { code: 10, label: "Schattenfugenrahmen" },
                { code: 11, label: "PLAN" },
            ],
        },
        BK_Größe_Briefkasten: {
            label: "Größe",
            field: "config_params.postbox_size_code",
            choices: [
                { code: 1, label: "S / 260 x 330 x 100 / 8 Liter" },
                { code: 2, label: "S / 370 x 330 x 100 / 12 Liter" },
                { code: 3, label: "M / 370 x 330 x 145 / 17 Liter" },
                { code: 4, label: "L / 370 x 440 x 145 / 23 Liter" },
                { code: 7, label: "M / 300 x 440 x 160 / 21 Liter" },
                { code: 8, label: "L / 400 x 440 x 160 / 28 Liter" },
            ],
        },
        BK_Oberfläche: {
            label: "Oberfläche",
            field: "config_params.surface_code",
            choices: [
                {
                    code: 1,
                    label: "Aluminium, farbig (RAL)",
                    onSelect() {
                        window?.setTimeout(() => {
                            if (typeof $openRalChooserOverlay == "function") {
                                $openRalChooserOverlay()
                            }
                        }, 500)
                    },
                },
                { code: 2, label: "Edelstahl" },
            ],
        },
        // PK_Anlagenart: {
        //     label: "Anlagenart",
        //     field: "config_params.system_type_code",
        //     choices: [
        //         { code: 1, label: "Brief- und Paketkasten" },
        //         { code: 2, label: "Paketkasten" },
        //     ],
        // },
        PK_Bedienung: {
            label: "Bedienung",
            field: "config_params.operation_type_code",
            choices: [
                { code: 1, label: "Mechanisch" },
                { code: 2, label: "Digital" },
            ],
        },
        // PK_Briefkästen: {
        //     label: "Briefkästen",
        //     field: "config_params.postboxes_count",
        //     choices: [
        //         { code: 0, label: "kein Briefkasten" },
        //         { code: 1, label: "1 Briefkasten" },
        //         { code: 2, label: "2 Briefkästen" },
        //     ],
        // },
        // PK_Paketfächer: {
        //     label: "Paketkästen",
        //     field: "config_params.packageboxes_code",
        //     choices: [
        //         { code: 1, label: "1x L" },
        //         { code: 2, label: "1x XL" },
        //         { code: 3, label: "1x XS, 1x XL" },
        //         { code: 4, label: "1x XS, 1x M, 1x XL" },
        //         { code: 5, label: "2x XS, 1x M, 1x XL" },
        //     ],
        // },
        PK_Funktion: {
            label: "Ausstattung",
            field: "config_params.division_code",
            choices: [
                { code: 1, label: "1 PK", labelLong: "1 Paketkasten" },
                { code: 2, label: "2 PK", labelLong: "2 Paketkästen" },
                { code: 3, label: "3 PK", labelLong: "3 Paketkästen" },
                { code: 4, label: "4 PK", labelLong: "4 Paketkästen" },
                {
                    code: 11,
                    label: "1 PK + 1 BK",
                    labelLong: "1 Paketkasten und 1 Briefkasten",
                },
                {
                    code: 12,
                    label: "1 PK + 2 BK",
                    labelLong: "1 Paketkasten und 2 Briefkästen",
                },
                {
                    code: 21,
                    label: "2 PK + 1 BK",
                    labelLong: "2 Paketkästen und 1 Briefkasten",
                },
                {
                    code: 111,
                    label: "1 PK + 1 BK + IK",
                    labelLong: "1 Paketkasten, 1 Briefkasten und Installationskasten",
                },
                {
                    code: 121,
                    label: "1 PK + 2 BK + IK",
                    labelLong: "1 Paketkasten, 2 Briefkästen und Installationskasten",
                },
                {
                    code: 211,
                    label: "2 PK + 1 BK + IK",
                    labelLong: "2 Paketkästen, 1 Briefkasten und Installationskasten",
                },
            ],
        },
        PK_Paketkastengröße: {
            label: "Paketkastengröße",
            field: "config_params.packagebox_size_code",
            choices: [
                { code: 1, label: "XS" },
                { code: 2, label: "S" },
                { code: 3, label: "M" },
                { code: 4, label: "L" },
                { code: 5, label: "XL" },
            ],
        },
        PK_Postentnahme: {
            label: "Postentnahme",
            field: "config_params.mail_removal_code",
            choices: [
                { code: 1, label: "Entnahme von vorn" },
                { code: 2, label: "Entnahme von hinten" },
            ],
        },
        // PK_Klingel: {
        //     label: "Sprechfeld / Klingel",
        //     field: "config_params.intercom_bell_code",
        //     choices: [
        //         { code: 1, label: "ohne Sprechfeld" },
        //         { code: 5, label: "mit Sprechfeld" },
        //     ],
        // },
        PK_Dachform: {
            label: "Dachform",
            field: "config_params.roof_type_code",
            choices: [
                { code: 1, label: "gerades Dach" },
                { code: 2, label: "schräges Dach" },
            ],
        },
    }

    let currentCtx: string = config[0]?.context

    function nextContext(forward = 1): boolean {
        let newContext: string
        let oldContext = currentCtx
        for (let i = 0; i < config.length; i++) {
            if (config[i].context == currentCtx) {
                if (config[i + forward]?.context) {
                    newContext = config[i + forward].context
                    setContext(newContext)
                }
                break
            }
        }

        if (innerWidth <= 768) {
            if (newContext) {
                scrollTo({ element: "#context-" + oldContext, offset: 40 })
            } else {
                scrollTo({ element: ".product_teaser", offset: -20 })
            }
        }
        return !!newContext
    }
    function prevContext() {
        nextContext(-1)
    }

    /*
    let oldHash
    $: if (oldHash != $location.hash) {
        oldHash = $location.hash
        */
    const hash = $location.hash?.replace(/^#/, "")
    if (hash) {
        try {
            const hObj = JSON.parse(atob(hash))
            if (hObj) {
                // console.log("HASH", hObj)
                for (let k in hObj.currentChoice) {
                    currentChoice[k] = hObj.currentChoice[k]
                }
                currentCtx = hObj.currentCtx
                activeColor = hObj.activeColor
                activeOptions = hObj.activeOptions
                choice2Filter(currentChoice)
            }
        } catch (e) {
            console.log(e)
        }
    }
    //}

    let contextBacknav = false
    let hasNext = config[config.length - 1]?.context != currentCtx
    let hasPrev = config[0]?.context != currentCtx
    function setContext(context: string) {
        let currentFound = false
        for (let i = 0; i < config.length; i++) {
            if (context == config[i].context) {
                hasPrev = i != 0
                hasNext = i < config.length - 1
                contextBacknav = !currentFound
                currentCtx = context
                break
            }
            if (currentCtx == config[i].context) {
                currentFound = true
            }
        }
    }

    function navigationToHash(hash: string) {
        navigate($location.path + "#" + hash, { replace: true })
    }
    $: if (currentChoice && currentField) {
        let hash = ""
        try {
            if (typeof btoa !== "undefined") {
                hash = btoa(
                    JSON.stringify({
                        currentChoice,
                        currentCtx,
                        activeColor,
                        activeOptions,
                    })
                )
            }
            navigationToHash(hash)
        } catch (e) {
            console.log(e)
        }
    }

    let oldConfig = config
    $: if (oldConfig != config) {
        oldConfig = config
        // reset
        currentField = undefined
        currentCtx = config[0]?.context
        currentChoice = {}
        hasNext = true
        hasPrev = false
        currentFilter = undefined
    }

    const completeOfferAssistantInquiry = (e) => {
        $contentOverlay = {
            component: ProductInquiry,
            props: {
                offerAssistantConfiguration: e.detail,
                submitInquirySuccessCallback,
            },
        }
    }

    const submitInquirySuccessCallback = () => {
        offerAssistantReset = true
        $showOfferAssistant = false
    }

    // skip next if only one choice
    let _oldCtx = currentCtx
    $: {
        if (!contextBacknav && _oldCtx != currentCtx) {
            _oldCtx = currentCtx
            let i = 0
            let code: number
            for (let k in validCodes) {
                if (validCodes[k]) {
                    i++
                    code = parseInt(k)
                }
            }
            if (i == 1) {
                const choices = contextConf[currentCtx]?.choices

                for (let ii = 0; ii < choices?.length; ii++) {
                    if (choices[ii].code == code) {
                        currentChoice[currentCtx] = choices[ii]
                        window.setTimeout(() => {
                            nextContext()
                        }, 200)
                        break
                    }
                }
            }
        }
    }
</script>

<svelte:window bind:innerWidth />

<div id="mailboxfilter">
    <div class="headline">
        <div class="headline-container">
            <h1>
                {#if $showOfferAssistant}
                    {$_("offer-assistant.title")}
                {:else}
                    {$_("product-config.configurator")}
                {/if}
            </h1>

            {#if !$showOfferAssistant && $breadcrumbs?.length >= 2 && $breadcrumbs[$breadcrumbs.length - 2].children?.length}
                <!-- svelte-ignore a11y-missing-attribute -->
                <!-- svelte-ignore a11y-click-events-have-key-events -->
                <a on:click="{() => (configopen = !configopen)}" class="conftype" class:active="{configopen}"
                    >{langField($breadcrumbs[$breadcrumbs.length - 1]?.name, "")}
                    <span class="arrow">
                        <ChevronDownIcon size="24px" />
                    </span>
                </a>

                <!-- svelte-ignore a11y-click-events-have-key-events -->
                <div
                    class="select_configtypes"
                    class:active="{configopen}"
                    on:click="{() => {
                        configopen = false
                        $showOfferAssistant = false
                    }}"
                    use:clickOutside="{(target) => {
                        configopen = false
                    }}"
                >
                    {#each $breadcrumbs[$breadcrumbs.length - 2].childObjects as c (c.id)}
                        {#if c.filterConfig?.length}
                            <div class="item">
                                <div class="image">
                                    <img
                                        src="{c.image?.src ? c.image.src + '?filter=m' : '/media/kein-bild.jpg'}"
                                        alt=""
                                    />
                                </div>
                                <div class="text">
                                    <a href="{langField(c.path, '')}">{langField(c.name, "")}</a>
                                </div>
                                <a href="{langField(c.path, '')}" class="arrow">
                                    <ChevronDownIcon size="24px" />
                                </a>
                            </div>
                        {/if}
                    {/each}
                </div>
            {/if}
        </div>

        {#if $showOfferAssistant}
            <button
                class="btn btn-secondary closeOfferAssistant"
                on:click="{() => {
                    $showOfferAssistant = false
                }}">{$_("offer-assistant.close")}</button
            >
        {/if}
    </div>

    <div class="filter">
        {#if $showOfferAssistant}
            <OfferAssistant
                id="{offerAssistantId}"
                configUrl="{apiBaseURL}"
                ftpAssetsUrl="{OfferAssistantFTPAssetsUrl}"
                bind:reset="{offerAssistantReset}"
                bind:show="{$showOfferAssistant}"
                bind:currentChoices="{currentChoice}"
                on:complete-inquiry="{completeOfferAssistantInquiry}"
            />
        {:else}
            <div class="nav">
                <ul>
                    {#each config as c}
                        <li
                            class:active="{currentChoice[c.context]}"
                            class:current="{c.context === currentCtx}"
                            id="context-{c.context}"
                        >
                            <a
                                href="/"
                                on:click|preventDefault="{() => {
                                    setContext(c.context)
                                }}"
                            >
                                <span class="icon"><CheckIcon size="24px" /></span>
                                {contextConf[c.context]?.label || c.context}
                                {#if currentChoice[c.context]}
                                    <span class="small">{currentChoice[c.context].label}</span>
                                {/if}
                                <span class="arrow">
                                    <ChevronDownIcon size="24px" />
                                </span>
                            </a>
                            <div class="types_mobile" bind:clientWidth="{clientwidth}">
                                <div class="types_holder">
                                    {#if currentCtx === c.context}
                                        <MailboxFilterChoices
                                            items="{contextConf[c.context]?.choices}"
                                            imageBase="/media/econfig/{c.context}-"
                                            bind:choice="{currentChoice[c.context]}"
                                            {validCodes}
                                            on:change="{() => {
                                                window.setTimeout(() => {
                                                    nextContext()
                                                }, 200)
                                            }}"
                                        />
                                    {/if}
                                </div>
                                <div class="prev">&laquo;</div>
                                <div class="next">&raquo;</div>
                            </div>
                        </li>
                    {/each}
                    <!-- svelte-ignore a11y-click-events-have-key-events -->
                    <li
                        class="delete_filters"
                        on:click="{() => {
                            contextBacknav = true
                            currentChoice = {}
                            currentCtx = config[0]?.context
                            hasNext = true
                            hasPrev = false
                            if (innerWidth <= 768) {
                                scrollTo({ element: '#context-0' })
                            }
                        }}"
                    >
                        <span class="icon"><DeleteIcon size="24px" /></span>
                        {$_("product-config.reset-all")}
                    </li>
                </ul>
            </div>

            {#key currentCtx}
                <div class="types">
                    <MailboxFilterChoices
                        items="{contextConf[currentCtx]?.choices}"
                        imageBase="/media/econfig/{currentCtx}-"
                        bind:choice="{currentChoice[currentCtx]}"
                        {validCodes}
                    />
                    <div class="buttons">
                        {#if hasPrev}
                            <!-- svelte-ignore a11y-click-events-have-key-events -->
                            <div
                                class="prev"
                                on:click="{() => {
                                    prevContext()
                                }}"
                            >
                                &laquo; {$_("product-config.back")}
                            </div>
                        {/if}
                        <!-- svelte-ignore a11y-click-events-have-key-events -->
                        {#if hasNext}
                            <div
                                class="next"
                                on:click="{() => {
                                    nextContext()
                                }}"
                            >
                                {$_("product-config.next")} &raquo;
                            </div>
                        {/if}
                    </div>
                </div>
            {/key}

            {#if previewProduct}
                {#key previewProduct}
                    <MailboxFilterProductPreview product="{previewProduct}" bind:activeColor bind:activeOptions />
                {/key}
            {/if}
        {/if}
    </div>
</div>

<style lang="less">
    @import "../../../css/variables.less";

    #mailboxfilter :global {
        .closeOfferAssistant {
            justify-self: flex-end;
            align-self: center;
        }
        .select_mobile {
            display: none;
        }
        .headline {
            padding: 0px 40px;
            border-bottom: 1px solid var(--border-color-default);
            .flex();
            justify-content: space-between;
            align-items: stretch;
            position: relative;

            @media (max-width: 1300px) {
                padding: 0px 20px;
            }

            .headline-container {
                display: flex;
            }

            h1 {
                .flex();
                align-items: center;
                justify-content: center;
                margin: 0px;
                font-size: 1.5rem;
                padding: 15px 0px;
            }
            .arrow {
                display: block;
                position: relative;
                right: 0;
                bottom: 0;
                top: 0;
                .flex();
                flex-direction: column;
                align-items: center;
                justify-content: center;
                width: 30px;
                transition: all 0.3s;
                svg {
                    width: 40px;
                }
            }
            .conftype {
                position: relative;
                .flex();
                margin-left: 15px;
                transition: all 0.3s;
                cursor: pointer;
                align-items: center;
                padding: 5px 5px 0px 15px;
                border-bottom: solid 3px transparent;
                &:hover,
                &.active {
                    background: var(--background);
                    border-bottom-color: var(--primary);
                }
                &.active {
                    .arrow {
                        transform: rotate(180deg);
                    }
                }
            }
            .subline {
                margin: 0px;
                text-align: center;
            }

            .select_configtypes {
                box-shadow: 0px 8px 5px -3px rgba(0, 0, 0, 0.3);
                z-index: 200;
                position: absolute;
                top: 100%;
                left: 100px;
                right: 0;
                .opacity(0);
                visibility: hidden;
                .flex();
                flex-direction: column;
                width: 25%;
                max-width: 400px;
                margin-top: 1px;
                transition: all 0.3s;
                border-bottom: 1px solid var(--border-color-default);
                border-left: 1px solid var(--border-color-default);
                border-right: 1px solid var(--border-color-default);
                @media (max-width: 1450px) {
                    width: 30%;
                }
                @media (max-width: 1180px) {
                    width: 50%;
                }
                @media (max-width: 768px) {
                    width: 100%;
                    max-width: 100%;
                    left: 0px;
                    border-left: 0;
                    border-right: 0;
                }
                &.active {
                    .opacity(1);
                    visibility: visible;
                }
                .item {
                    height: 50px;
                    position: relative;
                    transition: all 0.3s;
                    border-bottom: 1px solid var(--border-color-default);
                    &:last-child {
                        border-bottom: 0;
                    }
                    .flex();
                    .image {
                        width: 60px;
                        img {
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                        }
                    }
                    .text {
                        padding: 0px 40px 0px 20px;
                        .flex();
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        line-height: 1.2;
                        font-size: 0.8rem;
                        @media (max-width: 768px) {
                            font-size: 1rem;
                        }
                        a {
                        }
                    }
                    .arrow {
                        transform: rotate(-90deg);
                        position: absolute;
                        top: 0;
                        right: 0;
                        bottom: 0;
                        width: 50px;
                    }
                    &:hover {
                        background: var(--surface);
                    }
                }
            }
        }

        .filter {
            .flex();
            flex-wrap: wrap;
            padding: 50px;
            background: var(--background);
            .nav {
                width: 15%;
                flex-shrink: 0;
                background: var(--secondary);
                color: var(--on-secondary);

                ul {
                    list-style-type: none;
                    margin: 0;
                    padding: 0;
                    height: 100%;
                    .flex();
                    flex-direction: column;
                    li {
                        flex: 1;
                        .types_mobile {
                            display: none;
                        }
                        a,
                        &.delete_filters {
                            transition: all 0.3s;
                            background: var(--secondary);
                            color: var(--primary);
                            .flex();
                            height: 100%;
                            @media (max-width: 768px) {
                                height: 50px;
                            }
                            align-items: center;
                            flex-wrap: wrap;
                            padding-left: 20px;
                            padding-right: 10px;
                            border-bottom: 1px solid var(--border-color-3);
                            border-left: solid 5px transparent;
                            .icon :global {
                                .flex();
                                flex-direction: column;
                                align-items: center;
                                justify-content: center;
                                width: 15px;
                                margin-right: 20px;
                                @media (max-width: 1024px) {
                                    margin-right: 7px;
                                }
                                svg {
                                    display: none;
                                }
                            }
                            .arrow {
                                display: none;
                            }

                            .small {
                                width: 100%;
                                margin-top: -4px;
                                margin-left: 0px;
                                padding-left: 40px;
                                font-size: 14px;
                                color: rgba(255, 255, 255, 0.7);
                                transition: all 0.3s;
                                @media (max-width: 768px) {
                                    padding-left: 30px;
                                }
                            }
                        }
                        &.delete_filters {
                            background: rgba(0, 0, 0, 0.2);
                            border-bottom: 0;
                            font-size: 0.8rem;
                            flex: none;
                            height: 45px;
                            cursor: pointer;
                            .icon :global {
                                svg {
                                    display: block;
                                }
                            }
                            &:hover {
                                background: var(--primary);
                                color: var(--on-primary);
                            }
                        }
                        &:last-child a {
                            border-bottom: 0px;
                        }
                        &.active a {
                            // background: var(--background);
                            // border-left-color: rgba(0, 0, 0, 0.2);
                            color: var(--surface);
                            .small {
                                color: var(--surface);
                            }
                            .icon :global svg {
                                display: block;
                            }
                        }
                        &.current a {
                            background: var(--surface);
                            color: var(--primary);
                            border-left-color: var(--primary);
                            border-bottom-color: var(--border-color-default);
                            .icon :global svg {
                                display: block;
                            }
                            .small {
                            }
                        }
                        &.current a {
                            border-left-color: var(--primary);
                        }
                        &:hover a {
                            background: var(--surface);
                            color: var(--primary);
                            .small {
                            }
                        }
                    }
                }
            }
            .types {
                position: relative;
                background: var(--surface);
                width: 20%;
                min-height: 640px;
                @media (max-width: 1620px) {
                    min-height: 100px;
                }
                @media (max-width: 1450px) {
                    max-height: 50vw;
                    min-height: 100px;
                }
                @media (max-width: 1000px) {
                    max-height: 500px;
                }
                .buttons {
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    height: 45px;
                    border-top: 1px solid var(--border-color-default);
                    .flex();
                    .prev,
                    .next {
                        cursor: pointer;
                        border-right: 1px solid var(--border-color-default);
                        flex: 1;
                        .flex();
                        align-items: center;
                        justify-content: center;
                    }
                    > div:last-child {
                        border-right: 0;
                    }
                }
                .mailboxfilter_types {
                    .flex();
                    flex-wrap: wrap;
                    align-items: flex-start;
                    padding: 20px 50px 60px 50px;
                    @media (max-width: 1700px) {
                        padding: 20px 30px 60px 30px;
                    }
                    @media (max-width: 1450px) {
                        padding: 20px 50px 60px 50px;
                    }
                    @media (max-width: 1140px) {
                        padding: 20px 30px 60px 30px;
                    }
                    .item {
                        margin: 1%;
                        background: var(--surface-2);
                        color: var(--on-surface-2);
                        min-height: 5vw;
                        width: 31%;
                        cursor: pointer;
                        .flex();
                        flex-direction: column;
                        align-items: center;
                        justify-content: space-between;

                        &.transparent {
                            opacity: 0.001 !important;
                        }

                        @media (max-width: 1930px) {
                            width: 48%;
                            min-height: 7vw;
                        }
                        @media (max-width: 1450px) {
                            width: 48%;
                            min-height: 10vw;
                            height: auto;
                        }

                        .image {
                            padding: 0px 15px;
                            line-height: 0;
                            margin-top: 5px;
                            width: 100%;
                            height: 100%;

                            img {
                                width: 100%;
                                height: 100%;
                                object-fit: contain;
                            }
                        }
                        .text {
                            font-size: 14px;
                            line-height: 1.2;
                            text-align: center;
                            padding: 0px 5px 5px 5px;
                        }
                    }
                }
            }
        }

        @media (max-width: 1450px) {
            .filter {
                .nav {
                    width: 20%;
                }
                .types {
                    width: 30%;
                }
            }
        }
        @media (max-width: 1000px) {
            .headline {
                h1 {
                    font-size: 1.3rem;
                }
                .subline {
                    display: none;
                }
            }
            .filter {
                .types {
                    display: none;
                }
                .nav {
                    width: 50%;
                    ul li {
                        flex: none;
                    }
                    ul li a {
                        position: relative;
                        height: 40px;
                        flex-wrap: nowrap;
                        .arrow {
                            display: block;
                            position: absolute;
                            width: 50px;
                            right: 0;
                            top: 0;
                            bottom: 0;
                            .flex();
                            flex-direction: column;
                            align-items: center;
                            justify-content: center;
                        }
                    }
                    ul li {
                        &.current a .arrow {
                            color: rgba(0, 0, 0, 0.5);
                        }
                        a {
                            padding-left: 10px;
                            .icon {
                                margin-right: 10px;
                                svg {
                                    width: 18px;
                                }
                            }
                        }
                    }
                    ul li {
                        &.current {
                            .types_mobile {
                                .types_holder {
                                    position: relative;
                                    overflow-x: scroll;
                                    width: 100%;
                                    display: block;
                                }
                                .prev,
                                .next {
                                    font-size: 1.3rem;
                                    position: absolute;
                                    top: 0;
                                    bottom: 0;
                                    width: 50px;
                                    background: var(--surface);
                                    color: var(--surface);
                                    .flex();
                                    align-items: center;
                                    justify-content: center;
                                    display: none;
                                }
                                .left {
                                    left: 0;
                                }
                                .next {
                                    right: 0;
                                }
                                position: relative;
                                display: block;
                                width: 100%;
                                background: var(--surface-2);
                                color: var(--on-surface-2);
                                .mailboxfilter_types {
                                    width: auto;
                                    .flex();
                                    flex-wrap: nowrap;

                                    .item {
                                        width: 100px;
                                        height: auto;
                                        flex-shrink: 0;
                                        padding: 10px;
                                        margin: 10px;
                                        font-size: 0.7rem;
                                        .flex();
                                        flex-direction: column;
                                        align-items: center;
                                        text-align: center;
                                        width: 100%;
                                        height: 100%;

                                        @media (max-width: 1000px) {
                                            width: auto;
                                        }

                                        img {
                                            width: 100%;
                                            height: 100%;
                                            object-fit: contain;
                                        }

                                        &.transparent {
                                            opacity: 0.001 !important;
                                        }
                                    }
                                }
                            }
                            a {
                                .arrow {
                                    transform: rotate(180deg);
                                }
                            }
                        }
                    }
                }
            }
        }
        @media (max-width: 768px) {
            .filter {
                padding: 0px;
                .nav {
                    width: 100%;
                    margin-bottom: 30px;
                    ul li.delete_filters {
                        height: 40px;
                        flex: none;
                    }
                }
            }
        }
    }
</style>
